import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Divider,
  Typography,
} from "@mui/material";
import React from "react";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";

const DeleteInSaveDialog = ({ open, setOpen, handleDeleteInSave }) => {
  const handleClose = () => {
    setOpen(false);
  };
  const approvalRolesData = useSelector(
    (state) => state.mainToCard.approvalRolesData
  );

  let content, action;

  const url = useLocation().pathname;

  switch (url) {
    case "/approval-roles":
      content = (
        <>
          {approvalRolesData[0] ? (
            //  &&
            // approvalRolesData[0].approveRoleName &&
            // approvalRolesData[0].approveRoleId > 0
            <Typography component="span">
              Are you sure, you want to delete{" "}
              {approvalRolesData[0].approveRoleName} ?
            </Typography>
          ) : (
            <Typography component="span">Role not found</Typography>
          )}
        </>
      );

      action = (
        // approvalRolesData[0]?.approveRoleId > 0 &&
        <Button
          variant="contained"
          onClick={() => {
            handleClose();
            handleDeleteInSave();
          }}
        >
          Delete
        </Button>
      );
      break;

    default:
      content = null;
      break;
  }

  return (
    <div>
      <Dialog open={open} onClose={handleClose} fullWidth>
        <DialogTitle>Delete</DialogTitle>
        <Divider />
        <DialogContent>
          <DialogContentText>{content}</DialogContentText>
        </DialogContent>
        <DialogActions>
          {action}
          <Button variant="outlined" onClick={handleClose} sx={{color: 'gray', borderColor: '#D3D3D3'}}>Cancel</Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default DeleteInSaveDialog;
